// 藥物統計 component

<template lang="pug">
div
  div.upper-subpanel(style="margin: 0 -15px;")
    div.summary-layout
      table.table.table-fixed
        thead.thead-light
          tr
            th 藥碼
            th 料位號
            th 藥物名稱
            th 藥盒數量
            th 總數量
        tbody
          tr(v-for="data in summaryData")
            td {{ data.medication.code }}
            td {{ data.medication.CGMH_number}}
            td {{ data.medication.generic_name }}
            td {{ data.count }}
            td {{ data.total}}
  BottomButtons
    action-button(title="回主畫面" slot="button-1" @click.native="cancel")
</template>

<script>
import _ from 'lodash';
import BottomButtons from './common/BottomButtons';

export default {
  name: 'DrugStorageSummary',
  components: {
    BottomButtons,
  },
  created() {
    this.$store.commit('SET_APP', '藥物統計');
  },
  computed: {
    summaryData() {
      const summary = {};
      this.$store.getters.drugInDeviceList.forEach((element) => {
        if (summary[element.medication.id] === undefined) {
          summary[element.medication.id] = {};
          summary[element.medication.id].medication = element.medication;
          summary[element.medication.id].medication_CGMH_number = element.medication.CGMH_number;
          summary[element.medication.id].total = 0;
          summary[element.medication.id].count = 0;
        }
        summary[element.medication.id].total += element.stock;
        summary[element.medication.id].count += 1;
      });
      return _.orderBy(Object.values(summary), ['medication_CGMH_number']);
    },
  },
  methods: {
    cancel() {
      this.$router.push({ name: 'Main' });
    },
  },
};
</script>

<style lang="sass">
.summary-layout
  height: 100%
  width: 100%
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar-track
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 15px;
    background-color: #F5F5F5;
  &::-webkit-scrollbar
    width: 12px;
    background-color: #F5F5F5;  
  &::-webkit-scrollbar-thumb
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555;

// thead, tbody, tr, td, th
//   display: block

// tbody
//   td
//     float: left

// thead
//   tr
//     th
//       float: left
</style>




// WEBPACK FOOTER //
// DrugStorageSummary.vue?166290c0